export const PROSPECT_TAB_CHANGE='PROSPECT_TAB_CHANGE'
export const IMPORTEDFILES_TAB_CHANGE='IMPORTEDFILES_TAB_CHANGE'
export const REVIEW_TAB_CHANGE='REVIEW_TAB_CHANGE'
export const GET_IMPORTED_FILES='GET_IMPORTED_FILES'
export const GET_REVIEW_DATA='GET_REVIEW_DATA'
export const GET_PROSPECT_DATA='GET_PROSPECT_DATA'
export const GET_PROSPECT_RESPONSE='GET_PROSPECT_RESPONSE' 
export const RESET_IMPORT='RESET_IMPORT'

